module.exports = __webpack_public_path__ + "static/media/icon_walk.c1916ae6.svg";